import { Component } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { withStyles } from "@mui/styles";
import { getCurrentFunctionName } from "../../performanceModeManager";
import "./EPIFormSection.css";
import { Document, Page, pdfjs } from "react-pdf";
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

const styles = (theme) => ({
    heading: {
        fontSize: theme.typography.pxToRem(15),
        flexBasis: "33.33%",
        flexShrink: 0,
    },
    AccordionSummaryContent: {
        content: {
            margin: 3,
        },
    },
});

class EPIFormDocumentSection extends Component {
    constructor(props) {
        super(props);

        this.state = {
            numPages: null,
        };
    }

    onDocumentLoadSuccess({ numPages }) {
        this.setState({ numPages });
    }

    render() {
        console.perfLog(getCurrentFunctionName());

        let documentElement = (
            <Document
                file={this.props.document.file}
                renderMode="svg"
                onLoadSuccess={this.onDocumentLoadSuccess.bind(this)}
            >
                {" "}
                {Array.from(new Array(this.state.numPages), (el, index) => (
                    <Page key={`page_${index + 1}`} pageNumber={index + 1} />
                ))}
            </Document>
        );

        return (
            <div
                className="col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding"
                style={{ marginTop: "10px" }}
                ref={(panel) => (this.panel = panel)}
            >
                <div className="col-lg-12 col-md-12 col-sm-12 col-12 row div-document">{documentElement}</div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        form: state.equipmentEPI.currentEquipmentEPIForm,
        activeUser: state.activeUser,
    };
};

const mapDispatchToProps = () => {
    return {};
};

export default compose(withStyles(styles), connect(mapStateToProps, mapDispatchToProps))(EPIFormDocumentSection);
